import React from "react";
import Intro from "./Intro/Intro";

const About = () => {
  return (
    <div>
      <Intro />
    </div>
  );
};

export default About;
